import { Box, Text, VStack, HStack } from "@chakra-ui/react";
import { FiPlus } from "react-icons/fi";

interface AudienceCreationCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick?: () => void;
  isDisabled?: boolean;
}

const AudienceCreationCard = ({
  title,
  description,
  icon,
  onClick,
  isDisabled = false,
}: AudienceCreationCardProps) => {
  return (
    <HStack
      w="full"
      flex={1}
      p={[2, 4]}
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
      backgroundColor="white"
      display="flex"
      alignItems="center"
      gap={3}
      cursor={isDisabled ? "not-allowed" : "pointer"}
      _hover={!isDisabled ? { borderColor: "blue.300" } : {}}
      transition="all 0.2s"
      opacity={isDisabled ? 0.5 : 1}
      onClick={!isDisabled ? onClick : undefined}
    >
      <Box
        w="12"
        h="12"
        borderRadius="md"
        backgroundColor="#F2F2F2"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {icon}
      </Box>
      <VStack
        alignItems="flex-start"
        justifyContent="center"
        flex={1}
        spacing={1}
        w="full"
      >
        <Text fontWeight="semibold" fontSize="sm" color="gray.800">
          {title}
        </Text>
        <Text fontWeight="medium" fontSize="sm" color="gray.400">
          {description}
        </Text>
      </VStack>
      <Box
        w="8"
        h="8"
        borderRadius="md"
        backgroundColor="white"
        border="1px solid"
        borderColor="gray.200"
        boxShadow="sm"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <FiPlus size={16} color="blue.500" strokeWidth={2} />
      </Box>
    </HStack>
  );
};

export default AudienceCreationCard;
